import React from 'react'
import './CheckBox.css'
import { TbCheck } from 'react-icons/tb';

export default function CheckBox({isSelected}) {
    return (
        <div className={`custom-checkbox ${isSelected ? 'checked' : ''}`}>
            {isSelected && <TbCheck strokeWidth={3} color='white' size={16} />}
        </div>
    )
}
